module.exports = __webpack_public_path__ + "static/img/frame1.f71e8c41.png";